// Site-wide custom behaviour, moved out of layout/theme.liquid.
// Loaded with defer, so the DOM is parsed when this runs.
(function () {
  // Fade in product badges once images have loaded
  window.addEventListener('load', function () {
    document.querySelectorAll('.product__main-photos .product-badges').forEach(function (badges) {
      badges.style.opacity = '1';
    });
  });

  // Slide-in mega menu
  (function () {
    const navItems = Array.from(document.querySelectorAll('.site-nav__item--has-dropdown'));
    const slideInMenu = document.getElementById('slideInMenu');
    const header = document.getElementById('SiteHeader');
    // Inverted logo only renders when the header has one set
    const whiteLogo = document.querySelector('.site-header__logo-link.logo--inverted');
    const greenLogo = document.querySelector('.site-header__logo-link.logo--has-inverted');

    if (!slideInMenu || !header) return;

    let menuTimeout; // Holds reference to the closing timeout

    function updateLogoAndLinks(active) {
      // Clearing inline display hands control back to the header CSS (transparent/sticky states)
      if (whiteLogo && greenLogo) {
        whiteLogo.style.display = active ? 'block' : '';
        greenLogo.style.display = active ? 'none' : '';
      }
      document.querySelectorAll('.site-nav__link').forEach((link, index) => {
        link.style.color = active && index < 7 ? 'white' : '';
      });
    }

    function openMenu(event) {
      const navItem = event.target.closest('.site-nav__item--has-dropdown');
      const submenu = navItem?.querySelector('.site-nav__dropdown');
      if (!submenu) return;

      clearTimeout(menuTimeout); // Cancel any scheduled close

      // The menu sits under the header; page scroll is locked while it's open, so measure once here
      document.documentElement.style.setProperty('--top-bar-offset', `${header.getBoundingClientRect().bottom}px`);

      slideInMenu.innerHTML = submenu.innerHTML;
      slideInMenu.classList.add('active');
      document.body.classList.add('no-scroll');
      updateLogoAndLinks(true);

      const fourthItem = document.querySelector('.site-nav__item--has-dropdown:nth-child(4)');
      if (fourthItem) {
        const coverWidth = fourthItem.getBoundingClientRect().right + 50;
        header.style.background = `linear-gradient(to right, #022c26 ${coverWidth}px, transparent ${coverWidth}px)`;
        slideInMenu.style.width = `${coverWidth}px`;
      }

      header.classList.add('header-active');
      slideInMenu.classList.toggle('first-item-active', navItem === navItems[0]);
    }

    function closeMenu() {
      slideInMenu.classList.remove('active', 'first-item-active');
      slideInMenu.innerHTML = '';
      header.style.background = '';
      slideInMenu.style.width = '';
      document.body.classList.remove('no-scroll');
      updateLogoAndLinks(false);
      header.classList.remove('header-active');
    }

    function scheduleClose() {
      menuTimeout = setTimeout(closeMenu, 250);
    }

    navItems.forEach((item) => item.addEventListener('mouseenter', openMenu));
    header.addEventListener('mouseleave', scheduleClose);
    slideInMenu.addEventListener('mouseleave', scheduleClose);
    slideInMenu.addEventListener('mouseenter', () => clearTimeout(menuTimeout)); // Cancel close if user hovers back in
  })();

  // Superscript ® in hero subtitles and ™ in hero titles
  const superscript = (symbol) => `<span style="font-size: 0.5em; vertical-align: super;">${symbol}</span>`;
  document.querySelectorAll('.hero__subtitle').forEach((el) => {
    if (el.innerHTML.includes('®')) el.innerHTML = el.innerHTML.replace(/®/g, superscript('®'));
  });
  document.querySelectorAll('.hero__title').forEach((el) => {
    if (el.innerHTML.includes('™')) el.innerHTML = el.innerHTML.replace(/™/g, superscript('™'));
  });

  // Smooth scroll for in-page links
  document.addEventListener('click', (e) => {
    const anchor = e.target.closest('a.smooth-scroll');
    const id = anchor?.getAttribute('href')?.replace(/^#/, '');
    const target = id && document.getElementById(id);
    if (!target) return;
    e.preventDefault();
    target.scrollIntoView({ behavior: 'smooth' });
  });

  // Analytics: custom events for Shopify.analytics
  function publish(name, data) {
    if (window.Shopify && Shopify.analytics) Shopify.analytics.publish(name, data);
  }

  // Track misc forms
  const TRACKED_FORMS = 'form#recover_customer_password, form#customer_login, form#guest_login, form.contact-form';
  document.addEventListener('submit', (e) => {
    if (e.target.matches(TRACKED_FORMS)) publish('form_posted', { elementId: e.target.id });
  });

  // Track tel, email and other absolute link clicks
  document.addEventListener('click', (e) => {
    const link = e.target.closest("a[href*=':']");
    if (!link) return;
    publish('link_clicked', {
      elementId: link.id,
      elementHref: link.href,
      elementValue: link.textContent.trim(),
    });
  });

  // Track Intercom contact form submissions (sections/contact-form-intercom.liquid)
  const formResponse = document.getElementById('form-response');
  if (formResponse) {
    const responseObserver = new MutationObserver(() => {
      if (formResponse.querySelector('.note--success')) {
        responseObserver.disconnect();
        publish('form_posted', { elementId: 'contact_form' });
      }
    });
    responseObserver.observe(formResponse, { childList: true });
  }

  // Google Merchant Reviews badge. platform.js is only included on matching pages
  // (see layout/theme.liquid) and calls initializeBadge once loaded.
  window.___gcfg = { lang: 'en' };

  window.initializeBadge = function () {
    const container = document.createElement('div');
    container.id = '___ratingbadge_0';
    container.classList.add('reviews-fade-in');
    document.body.appendChild(container);

    window.gapi.load('ratingbadge', function () {
      window.gapi.ratingbadge.render(container, {
        merchant_id: 100858892,
        position: 'BOTTOM_LEFT',
      });

      // Give the badge a moment to render its iframe
      setTimeout(function () {
        const badge = document.getElementById('___ratingbadge_0');
        if (!badge) return;

        badge.querySelector('iframe')?.setAttribute('title', 'Google Merchant Reviews Badge');

        // Keep hidden until the visitor scrolls
        badge.style.opacity = '0';
        badge.style.visibility = 'hidden';

        function reveal() {
          if (window.scrollY <= 10) return;
          window.removeEventListener('scroll', reveal);
          badge.style.opacity = '1';
          badge.style.visibility = 'visible';
          badge.classList.add('visible');
        }
        window.addEventListener('scroll', reveal, { passive: true });

        // Keep the badge's icon level with the Intercom launcher on the right. Both widgets are
        // positioned by their own scripts, iOS toolbars move things and the phone sticky Add to Cart
        // bar lifts the launcher, so measure the launcher's real position rather than using offsets.
        // Google draws its collapsed icon with its centre 28px below the top of its 64px box.
        const ICON_CENTRE = 28;
        let alignQueued = false;

        // The launcher slides when the sticky bar shows or hides (CSS transition on `bottom`), so aim
        // for where that slide ends rather than where it is now, letting both move together.
        function launcherTargetTop(launcher, rect) {
          const slide = launcher.getAnimations?.().find((a) => a.transitionProperty === 'bottom');
          if (!slide) return rect.top;
          const frames = slide.effect.getKeyframes();
          const endBottom = parseFloat(frames[frames.length - 1].bottom);
          const nowBottom = parseFloat(getComputedStyle(launcher).bottom);
          return isNaN(endBottom) || isNaN(nowBottom) ? rect.top : rect.top - (endBottom - nowBottom);
        }

        function align() {
          alignQueued = false;
          const launcher = Array.from(
            document.querySelectorAll('.intercom-lightweight-app-launcher, .intercom-launcher-frame')
          ).find((el) => el.getBoundingClientRect().height > 0);
          // No Intercom on the page: fall back to the CSS positions
          if (!launcher) {
            badge.style.removeProperty('margin-bottom');
            return;
          }
          const l = launcher.getBoundingClientRect();
          const b = badge.getBoundingClientRect();
          const offset = b.top + ICON_CENTRE - (launcherTargetTop(launcher, l) + l.height / 2);
          if (Math.abs(offset) < 1) return;
          const current = parseFloat(getComputedStyle(badge).marginBottom) || 0;
          badge.style.setProperty('margin-bottom', Math.round(current + offset) + 'px', 'important');
        }

        function queueAlign() {
          if (alignQueued) return;
          alignQueued = true;
          requestAnimationFrame(align);
        }

        window.addEventListener('scroll', queueAlign, { passive: true });
        window.addEventListener('resize', queueAlign);
        window.visualViewport?.addEventListener('resize', queueAlign);
        // Re-check when Intercom adds itself to the page, when the sticky bar toggles its <body> class
        // and when a drawer opens or closes (js-drawer-open on <html>), as both move the launcher
        new MutationObserver(queueAlign).observe(document.body, {
          childList: true,
          attributes: true,
          attributeFilter: ['class'],
        });
        new MutationObserver(queueAlign).observe(document.documentElement, {
          attributes: true,
          attributeFilter: ['class'],
        });
        queueAlign();
      }, 1000);
    });
  };
})();
